import { Injectable } from '@angular/core';
import { select, Store, Action } from '@ngrx/store';

import * as fromAppointment from './appointment.reducer';
import * as AppointmentSelectors from './appointment.selectors';
import * as AppointmentActions from './appointment.actions';
import { UpdateAppointmentDTO } from '@care-portals/api-interfaces';

@Injectable()
export class AppointmentFacade {
  loading$ = this.store.pipe(
    select(AppointmentSelectors.getAppointmentLoading)
  );
  updating$ = this.store.pipe(
    select(AppointmentSelectors.getAppointmentUpdating)
  );
  allAppointment$ = this.store.pipe(
    select(AppointmentSelectors.getAllAppointment)
  );
  selectedAppointment$ = this.store.pipe(
    select(AppointmentSelectors.getSelected)
  );
  position$ = this.store.pipe(select(AppointmentSelectors.getPosition));

  constructor(private store: Store<fromAppointment.AppointmentPartialState>) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }
  loadAllAppointments() {
    this.dispatch(AppointmentActions.loadAllAppointments());
  }

  loadAppointment(id: string) {
    this.dispatch(AppointmentActions.loadAppointment({ id }));
  }

  updateAppointment(id: string, appointment: UpdateAppointmentDTO) {
    this.dispatch(AppointmentActions.updateAppointment({ id, appointment }));
  }

  getQueuePosition() {
    this.dispatch(AppointmentActions.getQueuePosition());
  }
}
